export default __webpack_public_path__ + "src/assets/website.32c5b5f06a94e297ba2e0e44ee15d5f0.svg";